DriversService.$inject = ['$resource', 'StoresService', 'Alerts', '$q'];

function DriversService($resource, StoresService, Alerts, $q) {
    
    const baseUrl = 'api/drivers/:id';    
    const Drivers = $resource(baseUrl, null, {
        update: {
            method: 'PUT'
        },
        addHoliday: {
            method: 'POST',
            url: baseUrl + '/holidays'
        },
        deleteHoliday: {
            method: 'DELETE',
            url: baseUrl + '/holidays/:day'
        }
    });
    
    this.getDrivers = getDrivers;
    this.getDriver = getDriver;
    this.saveDriver = saveDriver;
    this.deleteDriver = deleteDriver;
    this.addHoliday = addHoliday;
    this.deleteHoliday = deleteHoliday;

    //storing state of drivers list filters and sorts so remembered when going back into the page
    this.driversListState = {
        sortOrder: 'firstName',
        searchCriteria: '',
        includeDeleted: false
    };

    function getDriver(id) {
        return Drivers.get({
            id
        }).$promise;
    }

    function getDrivers(week) {
        return StoresService.getStore().then(store => {
            return Drivers.query({
                storeId: store.storeId,
                week: week && new Date(week).toISOString().slice(0, 10)
            }).$promise;
        });
    }

    function saveDriver(driver) {
        const method = driver.id === 0 ? Drivers.save : Drivers.update;
        return StoresService.getStore().then(store => {
            driver.storeId = store.storeId;
            return method({}, driver).$promise.then(() => {
                Alerts.show('Success!', 'Driver Saved!', 'success');
            });
        });
    }

    function deleteDriver(driver, updateLeaveDate) {
        const name = driver.firstName || 'this driver';
        const deferred = $q.defer();

        Alerts.show({
            text: 'Are you sure you want to delete ' + name + '?',
            title: 'Are you sure?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes!',
            closeOnConfirm: false
        }, () => {

            function callDelete(){
                Drivers.delete({
                id: driver.id
                }).$promise.then(() => {
                    Alerts.show('Deleted!', 'This driver has been deleted.', 'success');
                    deferred.resolve();
                });
            }
            
            if (updateLeaveDate){
                Drivers.update({},driver).$promise.then(() => {
                    callDelete();
                });
            }else{
                callDelete();
            }
            
        });

        return deferred.promise;
    }
    
    function addHoliday(driver, date) {
        const dateStr = getDateStringForUrl(date);
        const urlParams = {id: driver.id}; 
        const holiday = {day: dateStr};
        return Drivers.addHoliday(urlParams, holiday).$promise;
    }
  
    function deleteHoliday(driver, date) {
        const dateStr = getDateStringForUrl(date);
        const urlParams = {id: driver.id, day: dateStr};
        return Drivers.deleteHoliday(urlParams).$promise;
    }
    
    function getDateStringForUrl(date) {
        const d = new Date(date);
        d.setHours(12); //protecting against daylight savings time issues by making sure loss of an hour will not change day
        return d.toISOString().substr(0,10);
        
    }
}

export default DriversService;



// WEBPACK FOOTER //
// ./src/js/services/drivers/index.js